<template>
  <div class="Item-Row">
    <div class="Item-Info">
      <div class="Item-Title">
        <strong class="cart-item__name">{{ cart_item.name }}</strong>
        <span class="remove-cart-item" v-show="can_remove" @click="confirm_delete(cart_item.id)">
          {{ $t('cart.cta_remove_product') }}
        </span>
      </div>

      <div class="Item-Quantity">
        <div>
          <select class="cart-item--quantity" v-model="cart_item.quantity" @change="update_quantity({cart_id: cart_item.id, quantity: cart_item.quantity})">
            <option v-for="n in 100">{{ n }}</option>
          </select>
        </div>

        <div>
          <span class="cart-inner__items--price">{{ cart_item.price_final | formatCurrency(currency) }}</span>
        </div>
      </div>
    </div>

    <div>
      <template v-for="modifier in cart_item.list_modifiers">
        <div class="Modifier">
          <div class="Modifier-group-name" v-show="modifier.group">{{ modifier.group }}</div>
          <div class="Modifier-Title">
            {{ modifier.name }}
          </div>
          <div class="Modifier-Amount">
            {{ modifier.type === 'FIXED_DECREASE' ? '-' : '+'}}
            {{ modifier.amount | formatCurrency(currency) }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    props: [ 'cart_item', 'currency', 'can_remove' ],

    computed: {

    },

    methods: {
      ...mapActions([
        'delete_item',
        'update_quantity',
        'apply_coupon',
        'remove_coupon',
      ]),

      confirm_delete (cart_id) {
        this.delete_item(cart_id);
      },
    }
  };
</script>

<style scoped>

  .Item-Row {
    display: flex;
    flex-direction: column;
    font-family: 'Roboto';
    color: #333;
    font-weight: 300;
    /* border-bottom: 1px rgb(177, 177, 177) dashed; */
    margin-bottom: 14px;
  }

  .Item-Info {
    display: flex;
    justify-content: space-between;
  }

 .Item-Other {
    /* display: flex;
    justify-content: space-between; */
  }

  .Item-Title {
    width: 63%;
    font-family: 'Roboto Condensed';
    color: #333;
    font-weight: 400;
  }

  .Item-Quantity {
    flex:1;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .Modifier-group-name {
    display: block;
    font-weight: 700;
  }

  .Modifier {
    display: flex;
    justify-content: space-between;
  }

  .Modifier-Title {
    width: 70%;
  }

  .Modifier-Amount {
    font-family: 'Roboto Condensed';
    font-weight: 300;
  }

  .cart-inner__items--price {
    font-family: 'Roboto Condensed';
    color: rgb(4, 190, 91);
    font-size: 1.2em;
    font-weight: 400;
  }
  .cart-item--quantity {
    outline: none;
  }

  .remove-cart-item {
    font-family: 'Roboto Condensed';
    cursor: pointer;
    text-transform: lowercase;
    color: rgb(255, 67, 67);
  }
</style>



// WEBPACK FOOTER //
// items-row.vue?038dca89